export default { sha: 'c7831d2b6f0d4970254e71641a0aa40ad606a6c7', buildNumber: 'undefined' }
